export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export interface IManufacturing {
  isManufacturedByIngrooves: boolean;
  manufacturerName: string | null;
  explicitLyrics?: 'Explicit' | 'Clean' | null;
  ingroovesCanadaRight: boolean;
  countryOfManufacture?: string | null;
  manufacturingCostPerUnit?: number | null;
  currency?: Currency | null;
}
